/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpdateTagLangRequestViewModel } from "../types/UpdateTagLangRequestViewModel.ts";

export const updateTagLangRequestViewModelSchema = z.object({
  cultureInfo: z.string().nullish(),
  tagTitle: z.string().nullish(),
}) as unknown as ToZod<UpdateTagLangRequestViewModel>;
